// ** React Imports
import { lazy } from 'react';

const NotificationRoutes = [
  {
    path: 'notifications',
    component: lazy(() => import('views/notification')),
  },
  {
    path: 'notification/add',
    component: lazy(() => import('views/notification/notification-add')),
  },
  {
    path: 'notification/:id',
    component: lazy(() => import('views/notification/notification-detail')),
  },
  {
    path: 'notification/edit/:id',
    component: lazy(() => import('views/notification/notification-edit')),
  },
  {
    path: 'notification-clone/:id',
    component: lazy(() => import('views/notification/notification-clone')),
  },
];

export default NotificationRoutes;
